import { PhoneNumberUtil } from 'google-libphonenumber';

export const getPhoneUtil = () => {
  return PhoneNumberUtil.getInstance();
};
